export const BACKGROUND_BLUR_STRENGTH_MIN = 1
export const BACKGROUND_BLUR_STRENGTH_MAX = 15
export const BACKGROUND_BLUR_STRENGTH_DEFAULT = 4
export const BACKGROUND_BLUR_STRENGTH_STEP = 0.5

export const isBackgroundBlurEnabled = (value: unknown): boolean => value === true

export const parseBackgroundBlurStrength = (value: unknown): number => {
  const numeric = typeof value === 'number' ? value : Number(value)
  if (!Number.isFinite(numeric)) {
    return BACKGROUND_BLUR_STRENGTH_DEFAULT
  }
  return Math.min(
    BACKGROUND_BLUR_STRENGTH_MAX,
    Math.max(BACKGROUND_BLUR_STRENGTH_MIN, Math.round(numeric * 2) / 2),
  )
}
